import PropTypes from 'prop-types';
import styled from 'styled-components';

import Img from '~/components/Img';
import WysiwygText from '~/components/WysiwygText';
import { colors } from '~/utils/css-mixins';
import media from '~/utils/media';
import { imagePropType } from '~/utils/prop-types';

const Root = styled.div`
  margin-top: 1.5rem;
  ${media.tablet`
    margin-top: 2rem;
  `}
  background-color: #f8f7f5;
  padding: 25px;
  border: 1px solid ${colors.border};

  h2 {
    margin: 15px 0;
  }

  h3 {
    margin-bottom: 0;
  }
`;

const StyledImg = styled(Img)`
  display: block;
  width: 100%;
  max-width: 250px;
  margin-top: -25px;
  margin-left: -25px;
`;

const FactBox = ({ image, text }) => (
  <Root>
    {image && <StyledImg image={image} width={250} />}
    <WysiwygText html={text} />
  </Root>
);

FactBox.propTypes = {
  image: imagePropType,
  text: PropTypes.string,
};

export default FactBox;
